import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "1em", height: "1em", ...props, children: _jsx("path", { d: "m9.3 12-.9-1 2.4-2.4H2.7V7.3h8.1L8.4 4.9l.9-1 4 4-4 4Z", "data-name": "\\u5716\\u5C64_1" }) }));
export default SvgArrowRight;
